import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useI18n } from "../i18n/I18nProvider";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full border border-white/10 bg-[#0a0a0a] p-10 text-center">
        <XCircle className="w-12 h-12 text-zinc-400 mx-auto mb-4" />
        <h1 className="font-heading font-black text-3xl tracking-tighter mb-3">Pagamento annullato</h1>
        <p className="text-zinc-400 text-sm mb-6">La tua prenotazione è stata salvata come &quot;in attesa&quot;. Puoi completare il pagamento più tardi contattandoci.</p>
        {bookingId && <div className="text-xs font-mono text-zinc-500 mb-6">Booking: {bookingId}</div>}
        <div className="flex gap-2 justify-center">
          <button onClick={() => navigate("/")} className="h-12 px-8 bg-scooter-yellow text-black font-bold text-xs tracking-[0.2em] uppercase" data-testid="cancel-home-btn">Home</button>
          <button onClick={() => navigate("/dashboard")} className="h-12 px-8 border border-white/20 font-bold text-xs tracking-[0.2em] uppercase hover:bg-white/5" data-testid="cancel-dashboard-btn">{t.nav.dashboard}</button>
        </div>
      </div>
    </div>
  );
}
